import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enLocaleResource from '../locales/en.json';
import enUSLocaleResource from '../locales/en-US.json';
import zhLocaleResource from '../locales/zh.json';
import zhHKLocaleResource from '../locales/zh-HK.json';
import frLocaleResource from '../locales/fr.json';
import deLocaleResource from '../locales/de.json';
import jaLocaleResource from '../locales/ja.json';
import koLocaleResource from '../locales/ko.json';
import esMXLocaleResource from '../locales/es-MX.json';
import ptBRLocaleResource from '../locales/pt-BR.json';
import viLocaleResource from '../locales/vi.json';

export const SUPPORT_LANGUAGES = {
  zh: 'zh',
  en: 'en',
  'zh-HK': 'zh-HK',
  fr: 'fr',
  'en-US': 'en-US',
  de: 'de',
  ja: 'ja',
  ko: 'ko',
  'es-MX': 'es-MX',
  'pt-BR': 'pt-BR',
  vi: 'vi',
} as const;
const TRANSLATION_LANG_KEY = Object.keys(SUPPORT_LANGUAGES);
export const DEFAULT_LANGUAGE = 'en';

i18n.use(initReactI18next).init({
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  keySeparator: '.',
  preload: TRANSLATION_LANG_KEY,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  react: {
    useSuspense: false,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['b', 'br'],
  },
  resources: {
    en: {
      translation: enLocaleResource,
    },
    'en-US': {
      translation: enUSLocaleResource,
    },
    zh: {
      translation: zhLocaleResource,
    },
    'zh-HK': {
      translation: zhHKLocaleResource,
    },
    fr: {
      translation: frLocaleResource,
    },
    de: {
      translation: deLocaleResource,
    },
    ja: {
      translation: jaLocaleResource,
    },
    ko: {
      translation: koLocaleResource,
    },
    'es-MX': {
      translation: esMXLocaleResource,
    },
    'pt-BR': {
      translation: ptBRLocaleResource,
    },
    vi: {
      translation: viLocaleResource,
    },
  },
});

export default i18n;

export const getLangKeyFromProps = (langKey = DEFAULT_LANGUAGE): string => {
  return TRANSLATION_LANG_KEY.includes(langKey) ? langKey : DEFAULT_LANGUAGE;
};
